import {
    DEALERADDUPDATEDSRLIMITS_FAILED,
    DEALERADDUPDATEDSRLIMITS_SUCCESS,
    RESET_DEALERADDUPDATEDSRLIMITS,
    LOADING_DEALERADDUPDATEDSRLIMITS,
    NETWORK_ERROR_DEALERADDUPDATEDSRLIMITS
} from '../types/index'


const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERADDUPDATEDSRLIMITS:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERADDUPDATEDSRLIMITS_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERADDUPDATEDSRLIMITS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERADDUPDATEDSRLIMITS:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERADDUPDATEDSRLIMITS:
            return (state = initialState);
        default:
            return state;
    }
};